import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as nodeUtils from "../../../abstract/controller/utils/nodeUtils";
import * as pathUtils from "../../../abstract/controller/utils/pathUtils";
import {
  getIsExtended,
  setMetaExtended,
  setMetaExtendedBulk,
  setMetaFoldedBulk,
} from "../../../abstract/redux/slice/metaSlice";
import IconArrowClockwise from "../../../themes/icons/IconArrowClockwise";
import IconWindowMaximize2 from "../../../themes/icons/IconWindowMaximize2";
import { IconWindowMaximize3 } from "../../../themes/icons/IconWindowMaximize3";
import IconWindowMinimize2 from "../../../themes/icons/IconWindowMinimize2";
import { IconWindowMinimize3 } from "../../../themes/icons/IconWindowMinimize3";
import Labels from "../../label/Labels";
import Meta from "../../meta/Meta";
import { ButtonOverlay } from "../../ui/buttons/ButtonOverlay";
import { Canvas } from "../canvas/Canvas";
import styles from "./BodyViewFunction.module.scss";

function BodyViewFunction({ nodeFunction, showFunction, setShowGlobals, setShowFunction }) {
  const _dispatch = useDispatch();

  const _isFolded = useRef(false);

  const _id = nodeUtils.getID(nodeFunction);
  const _uuid = nodeUtils.getUUID(nodeFunction);
  const _isExtended = useSelector(getIsExtended(_uuid));

  const _name = pathUtils.getName(_id);
  const _labels = nodeUtils.getLabel(nodeFunction);

  const handleButtonFold = (e) => {
    e.stopPropagation();

    _isFolded.current = !_isFolded.current;

    _dispatch(setMetaExtendedBulk(nodeFunction, false));
    _dispatch(setMetaFoldedBulk(nodeFunction, _isFolded.current));
  };

  const handleViewShow = () => {
    const _value = Boolean(showFunction);

    setShowFunction(!_value);
    setShowGlobals(true);

    _dispatch(setMetaExtended(_uuid, false));
  };

  const handleViewMeta = (e) => {
    e?.stopPropagation();

    _dispatch(setMetaExtended(_uuid, !_isExtended));
  };

  const handlePropagation = (e) => {
    e.stopPropagation();
  };

  return (
    <div className={styles["global"]}>
      <div className={styles["header"]} role="button" onClick={handleViewShow}>
        {showFunction && (
          <div
            className={`${styles["icon"]} ${styles["icon--fold"]}`}
            role="button"
            onClick={handleButtonFold}>
            <IconArrowClockwise />
          </div>
        )}
        <div className={styles["meta"]}>
          <div className={styles["meta__header"]}>{`Function : ${_name}`}</div>
          {showFunction && _labels.length > 0 && (
            <div className={styles["meta__labels"]}>
              <Labels node={nodeFunction} alignCenter />
            </div>
          )}
          <div className={styles["meta__data"]} onClick={handlePropagation}>
            <Meta node={nodeFunction} show={_isExtended} />
          </div>
        </div>
        <div className={`${styles["icon"]} ${styles["icon--meta"]}`} role="button">
          <ButtonOverlay handler={handleViewMeta}>
            {_isExtended ? <IconWindowMaximize2 /> : <IconWindowMinimize2 />}
          </ButtonOverlay>
        </div>
        <div className={`${styles["icon"]} ${styles["icon--show"]}`}>
          {showFunction ? <IconWindowMinimize3 /> : <IconWindowMaximize3 />}
        </div>
      </div>
      <div className={`${styles["container"]}`}>
        {showFunction && <Canvas node={nodeFunction} isResizable={false} />}
      </div>
    </div>
  );
}

export default BodyViewFunction;
